@if (facility$ | async; as facility) {
<app-add-edit-facility
  [facility]="facility"
  [submitText]="createNew(facility.id) ? 'Create' : 'Save'"
  (facilitySubmitted)="Submit($event)"
  (cancel)="navigateToFacilitiesList()"
></app-add-edit-facility>
}
